
//
//  CNNIX Virgil
//  @description :      Main JS for the CNNIX Virgil
//  @author :           Kenneth Uzquiano (kenneth.uzquiano@turner.com)
//

//  Link media
    require.context('../media/', true, /^\.\/.*\.*/);

//  Link fonts
    require.context('../webfonts/', true, /^\.\/.*\.*/);

//  Styles
    import '../styles/styles.scss';

// Scripts
    import inView from '../js/_in-view.js';
    import Plyr from '../js/_plyr.js';
    import '../js/_background-sizes.js';
    import '../js/_sharebar.js';

const ua = window.navigator.userAgent;
const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
const webkit = !!ua.match(/WebKit/i);
const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

if (iOSSafari == true){
  //console.log('safari');
}
else {
  //console.log('not safari');
  document.getElementsByTagName('body')[0].classList.add('not-ios-safari');
}

inView('#episode-01').on('enter', el => {
    const pretitle = document.getElementById('pretitle');
    pretitle.classList.add('is-visible');
}).on('exit', el => { 
});

inView('#credits').on('enter', el => {
    const pretitle = document.getElementById('pretitle');
    pretitle.classList.remove('is-visible');
}).on('exit', el => {  
});

inView('#boys').on('enter', el => {
    const pretitle = document.getElementById('pretitle');
    pretitle.classList.add('is-visible');
}).on('exit', el => {
});

inView('#cover').on('enter', el => {
    const pretitle = document.getElementById('pretitle');
    pretitle.classList.remove('is-visible');
}).on('exit', el => {
});

document.addEventListener('scroll',function() {
    const  scrollTop = document.documentElement['scrollTop'] || document.body['scrollTop'];
    const  scrollBottom = (document.documentElement['scrollHeight'] || document.body['scrollHeight']) - document.documentElement.clientHeight;
    const scrollPercent = scrollTop / scrollBottom * 100 + '%';
    document.getElementById('slide-progress').style.setProperty('--scroll', scrollPercent);
  },{ passive: true }
);

/*
 * Audio
 */
const players = new Plyr.setup('audio', {
    enabled: true,
    debug: false,
    controls: ['play', 'progress', 'current-time']
});

// timeupdate/audio is playing markers
let reached10  = false;
let reached25  = false;
let reached50  = false;
let reached75  = false;
let playerIndex = 0;
let playing = false;


players.forEach(function (player) {
  console.log(player);

  // audio function from analytics team
  function sendAudioEvent(data, event, playerid){
    try {
      var currVidObj = _w.JSON.parse(data);
      currVidObj.playerid = playerid;
      trackMetrics({
        type: event,
        data: {
          audio : currVidObj
        }
      });
    } catch(e){}
  }

  // audio function from analytics team
  function isStatus(){
    if(player.paused == false){
      return 'audio on'
    }
    else {
      return 'nvs'
    }
  }

  // audio buffer 
  player.on('progress', function(event){
    /* set analytics object */
    var metadata = {
      title: player.media.dataset.episode,
      id: player.media.dataset.podcast,
      state: 'nvs',
      status: isStatus(),
      position: 'inline audio',
      buffer: true
    }
    /* fire analytics object */
    try {
        sendAudioEvent(metadata, 'audio-buffer', player.media.dataset.podcast);
        console.log(metadata, 'audio-buffer', player.media.dataset.podcast);
    }
    catch(error) {
        console.log('error: '+error.message);
    }
  });

  function test(){
    console.log('test!');
  }

  // audio play
  player.on('play', function(event){
    //console.log(this);
    //console.log(player);

    // pause audio if another is played
    let current = player.media.dataset.episode;
    //console.log(current);
    players.forEach(function (player) {
     if (current != player.media.dataset.episode) {
        player.pause();
      }
    });

    let nowPlayings = document.querySelectorAll('.now-playing');
    nowPlayings.forEach(function (nowPlaying) {
      //console.log(nowPlaying);
      //console.log(nowPlaying.dataset.episode);

      if (nowPlaying.dataset.episode == player.media.dataset.episode){
        nowPlaying.innerHTML = ' : Now Playing'
      }
    });
    
    /* set analytics object */
    var metadata = {
      title: player.media.dataset.episode,
      id: player.media.dataset.podcast,
      state: 'nvs',
      status: isStatus(),
      position: 'inline audio'
    };

    /* fire analytics object */
    try {
        sendAudioEvent(metadata, 'audio-start', player.media.dataset.podcast);
        console.log(metadata, 'audio-start', player.media.dataset.podcast);
    }
    catch(error) {
        console('error: '+error.message);
    }
  });

  // audio pause
  player.on('pause', function(event){
    let nowPlayings = document.querySelectorAll('.now-playing');
    nowPlayings.forEach(function (nowPlaying) {
      //console.log(nowPlaying);
      //console.log(nowPlaying.dataset.episode);

      if (nowPlaying.dataset.episode == player.media.dataset.episode){
        nowPlaying.innerHTML = ''
      }
    });

    // audio natively pauses before end
    // only fire pause analytics if audio is paused -1 before end
    if(player.currentTime <= player.duration - 1){
      /* set analytics object */
      var metadata = {
        title: player.media.dataset.episode,
        id: player.media.dataset.podcast,
        state: 'nvs',
        status: isStatus(),
        position: 'inline audio',
        pause: true
      }
      /* fire analytics object */
      try {
          sendAudioEvent(metadata, true, 'audio-pause', player.media.dataset.podcast);
          console.log(metadata, true, 'audio-pause', player.media.dataset.podcast);
      }
      catch(error) {
          console('error: '+error.message);
      }
    }
  });

  // audio is playing
  player.on('timeupdate', function(event){
    /* set markers */
    var duration10 = Math.round(player.duration / 10);
    var duration25 = Math.round(player.duration / 4);
    var duration50 = Math.round(player.duration / 2);
    var duration75 = Math.round(player.duration / 1.3);

    /* set analytics object */
    var metadata = {
      title: player.media.dataset.episode,
      id: player.media.dataset.podcast,
      state: 'nvs',
      status: isStatus(),
      position: 'inline audio'
    }

    if(player.currentTime >= duration10 &&! reached10){
      /* fire analytics object */
      try {
        sendAudioEvent(metadata, 'audio-ten', player.media.dataset.podcast);
        console.log(metadata, 'audio-ten', player.media.dataset.podcast);
      }
      catch(error) {
        console('error: '+error.message);
      }
      reached10 = true;
    }
    if(player.currentTime >= duration25 &&! reached25){
      /* fire analytics object */
      try {
        sendAudioEvent(metadata, 'audio-twentyfive', player.media.dataset.podcast);
        console.log(metadata, 'audio-twentyfive', player.media.dataset.podcast);
      }
      catch(error) {
        console('error: '+error.message);
      }
      reached25 = true;
    }
    if(player.currentTime >= duration50 &&! reached50){
      /* fire analytics object */
      try {
        sendAudioEvent(metadata, 'audio-fifty', player.media.dataset.podcast);
        console.log(metadata, 'audio-fifty', player.media.dataset.podcast);
      }
      catch(error) {
          console('error: '+error.message);
      }
      reached50 = true;
    }
    if(player.currentTime >= duration75 &&! reached75){
      /* fire analytics object */
      try {
        sendAudioEvent(metadata, 'audio-seventyfive', player.media.dataset.podcast);
        console.log(metadata, 'audio-seventyfive', player.media.dataset.podcast);
      }
      catch(error) {
        console('error: '+error.message);
      }
      reached75 = true;
    }
  });

  // audio scrubbed
  player.on('seeking', function(event){
    /* set analytics object */
    var metadata = {
      title: player.media.dataset.episode,
      id: player.media.dataset.podcast,
      state: 'nvs',
      status: isStatus(),
      position: 'inline audio',
      scrub: true
    }
    /* fire analytics object */
    try {
        sendAudioEvent(metadata, 'audio-scrub', player.media.dataset.podcast);
        console.log(metadata, 'audio-scrub', player.media.dataset.podcast);
    }
    catch(error) {
        console('error: '+error.message);
    }
  });

  // audio ended
  player.on('ended', function (event) {
    let nowPlayings = document.querySelectorAll('.now-playing');
    nowPlayings.forEach(function (nowPlaying) {
      //console.log(nowPlaying);
      //console.log(nowPlaying.dataset.episode);

      if (nowPlaying.dataset.episode == player.media.dataset.episode){
        nowPlaying.innerHTML = ''
      }
    });

    /* set analytics object */
    var metadata = {
      title: player.media.dataset.episode,
      id: player.media.dataset.podcast,
      state: 'nvs',
      status: isStatus(),
      position: 'inline audio'
    }
    /* fire analytics object */
    try {
      sendAudioEvent(metadata, 'audio-complete', player.media.dataset.podcast);
      console.log(metadata, 'audio-complete', player.media.dataset.podcast);
    }
    catch(error) {
      console('error: '+error.message);
    } 
  });
});







// for elements that scroll horizontally, enable drag to scroll/navigate
//drag scroll timeline [0]
var isDown = false;
var startX;
var scrollLeft;
const dragScroll = document.getElementsByClassName('drag-scroll');

dragScroll[0].addEventListener('mousedown', function(e) {
  isDown = true;
  dragScroll[0].classList.add('dragging');
  startX = e.pageX - dragScroll[0].offsetLeft;
  scrollLeft = dragScroll[0].scrollLeft;
});

dragScroll[0].addEventListener('mouseleave', function() {
  isDown = false;
  dragScroll[0].classList.remove('dragging');
});

dragScroll[0].addEventListener('mouseup', function() {
  isDown = false;
  dragScroll[0].classList.remove('dragging');
});

dragScroll[0].addEventListener('mousemove', function(e) {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - dragScroll[0].offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  dragScroll[0].scrollLeft = scrollLeft - walk;
  //console.log(walk);
});


// WEBPACK FOOTER //
// ./src/js/main.js